import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange, itemsPerPage = 10, onItemsPerPageChange }) => {
    // Генерируем массив страниц для отображения
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5; // Сколько страниц показывать в пагинации

        if (totalPages <= maxVisiblePages) {
            // Если страниц мало, показываем все
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
            // Иначе показываем часть с текущей страницей в центре по возможности
            let start = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
            let end = Math.min(totalPages, start + maxVisiblePages - 1);

            // Корректируем начало, если конец достиг максимума
            if (end === totalPages) {
                start = Math.max(1, totalPages - maxVisiblePages + 1);
            }

            // Добавляем первую страницу + многоточие
            if (start > 1) {
                pages.push(1);
                if (start > 2) pages.push('...');
            }

            // Добавляем основные страницы
            for (let i = start; i <= end; i++) pages.push(i);

            // Добавляем многоточие + последнюю страницу
            if (end < totalPages) {
                if (end < totalPages - 1) pages.push('...');
                pages.push(totalPages);
            }
        }

        return pages;
    };

    // Обработчик изменения количества элементов на странице
    const handleItemsPerPageChange = (e) => {
        if (onItemsPerPageChange) {
            onItemsPerPageChange(Number(e.target.value));
        }
    };

    return (
        <div className="pagination">
            <button
                className="pagination-button"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                ← Назад
            </button>

            <div className="pagination-pages">
                {getPageNumbers().map((page, index) => (
                    page === '...' ? (
                        <span key={`ellipsis-${index}`} className="pagination-ellipsis">...</span>
                    ) : (
                        <button
                            key={page}
                            className={`pagination-page ${currentPage === page ? 'active' : ''}`}
                            onClick={() => onPageChange(page)}
                        >
                            {page}
                        </button>
                    )
                ))}
            </div>

            <button
                className="pagination-button"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                Вперед →
            </button>

            {onItemsPerPageChange && (
                <div className="pagination-items-per-page">
                    <span>Показувати по: </span>
                    <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
                        <option value="10">10 оголошень</option>
                        <option value="20">20 оголошень</option>
                        <option value="50">50 оголошень</option>
                    </select>
                </div>
            )}
        </div>
    );
};

export default Pagination;